import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'
import { jwtDecode } from 'jwt-decode'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { useAuthStore } from '../stores/auth-store'

dayjs.extend(duration)

interface jwtContextUser {
  user_admin: number
  user_email: string
  user_login: string
  user_name: string
  user_role: number
}

interface jwtContext {
  user: jwtContextUser
}

declare module 'jwt-decode' {
  export interface JwtPayload {
    context: jwtContext
    exp?: number
  }
}

const getLogin = (to, from, next) => {
  const authStore = useAuthStore()
  if (!localStorage.getItem('HMadminToken') || localStorage.getItem('HMadminToken') == '') {
    console.log('log me in')
    next('/auth/login')
    return
  }

  // console.log("log me not in " + localStorage.getItem("HMadminToken"))
  const decodedToken = jwtDecode(localStorage.getItem('HMadminToken'))
  console.log('DECODED TOKEN IN ROUTER', decodedToken)

  if (!decodedToken || !decodedToken.exp || !decodedToken.context) {
    next('/auth/login')
    return
  }
  const jetzt = Math.floor(Date.now() / 1000)
  if (jetzt > decodedToken.exp) {
    next('/auth/login')
    return
  }
  localStorage.setItem('userData', JSON.stringify(decodedToken.context.user))
  const exp = decodedToken.exp
  const now = dayjs().unix()
  if (exp < now) {
    authStore
      .authRefresh()
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.error('ERRRR ', err)
      })
  }
  next()
  return
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'dashboard' },
  },

  {
    name: 'admin',
    path: '/admin',
    component: AppLayout,
    beforeEnter: getLogin,
    children: [
      {
        name: 'download',
        path: 'download/:code',
        component: () => import('../pages/admin/Download.vue'),
        meta: {},
      },
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'actions',
        path: 'actions',
        component: RouteViewComponent,
        children: [
          {
            name: 'actionlist',
            path: 'list',
            component: () => import('../pages/admin/actions/ActionList.vue'),
            meta: {},
          },
          {
            name: 'actioncreate',
            path: 'create',
            component: () => import('../pages/admin/actions/ActionDetail.vue'),
            meta: {},
          },
          {
            name: 'actionedit',
            path: 'edit/:id',
            component: () => import('../pages/admin/actions/ActionDetail.vue'),
            meta: {},
          },
          {
            name: 'cloneaction',
            path: 'cloneaction/:id',
            component: () => import('../pages/admin/actions/ActionClone.vue'),
            meta: {},
          },
          {
            name: 'postprocess',
            path: 'postprocess/:id',
            component: () => import('../pages/admin/actions/PostProcessFilters.vue'),
            meta: {},
          },
          {
            name: 'formatteddelivery',
            path: 'formatteddelivery',
            component: () => import('../pages/admin/actions/FormattedDelivery.vue'),
            meta: {},
          },
          {
            name: 'actiondelivery',
            path: 'actiondelivery/:id',
            component: () => import('../pages/admin/actions/FormattedDelivery.vue'),
            meta: {},
          },
          {
            name: 'actiontemplates',
            path: 'actiontemplates',
            component: () => import('../pages/admin/actions/ActionTemplateList.vue'),
          },
          {
            name: 'actiontemplatecreate',
            path: 'templatecreate',
            component: () => import('../pages/admin/actions/ActionTemplateDetail.vue'),
            meta: {},
          },
          {
            name: 'actiontemplateedit',
            path: 'templateedit/:id',
            component: () => import('../pages/admin/actions/ActionTemplateDetail.vue'),
            meta: {},
          },
          {
            name: 'postprocessfilters',
            path: 'postprocessfilters',
            component: () => import('../pages/admin/actions/PostProcessFilterList.vue'),
          },
          {
            name: 'postprocessfilter',
            path: 'postprocessfilter/:id',
            component: () => import('../pages/admin/actions/PostProcessFilterDetail.vue'),
          },
          {
            name: 'userupload',
            path: 'userupload/:id',
            component: () => import('../pages/admin/actions/UserUpload.vue'),
          },
          {
            name: 'informpartner',
            path: 'informpartner/:id',
            component: () => import('../pages/admin/actions/InformPartners.vue'),
          },
          {
            name: 'uploadunsubscribes',
            path: 'uploadunsubscribes',
            component: () => import('../pages/admin/actions/UploadUnsubscribes.vue'),
          },
          {
            name: 'petitiontemplates',
            path: 'petitiontemplates',
            component: () => import('../pages/admin/actions/PetitionTemplateList.vue'),
          },
          {
            name: 'petitiontemplate',
            path: 'petitiontemplate/:id',
            component: () => import('../pages/admin/actions/PetitionTemplateDetail.vue'),
          },
        ],
      },
      {
        name: 'crm',
        path: 'crm',
        component: RouteViewComponent,
        children: [
          {
            name: 'clients',
            path: 'clients',
            component: () => import('../pages/admin/crm/ClientList.vue'),
          },
          {
            name: 'client',
            path: 'client/:id',
            component: () => import('../pages/admin/crm/ClientDetail.vue'),
          },
          {
            name: 'beneficiaries',
            path: 'beneficiaries',
            component: () => import('../pages/admin/crm/BeneficiaryList.vue'),
          },
          {
            name: 'beneficiary',
            path: 'beneficiary/:id',
            component: () => import('../pages/admin/crm/BeneficiaryDetail.vue'),
          },
          {
            name: 'informoptoutssettings',
            path: 'informoptoutssettings',
            component: () => import('../pages/admin/crm/InformOptoutsSettingsList.vue'),
          },
          {
            name: 'informoptoutssetting',
            path: 'informoptoutssetting/:id',
            component: () => import('../pages/admin/crm/InformOptoutsSettingsDetail.vue'),
          },
          {
            name: 'informoptoutspartnersettings',
            path: 'informoptoutspartnersettings',
            component: () => import('../pages/admin/crm/InformOptoutsPartnerSettingsList.vue'),
          },
          {
            name: 'informoptoutspartnersetting',
            path: 'informoptoutspartnersetting/:id',
            component: () => import('../pages/admin/crm/InformOptoutsPartnerSettingsDetail.vue'),
          },
          {
            name: 'deliverysettings',
            path: 'deliverysettings',
            component: () => import('../pages/admin/crm/DeliverySettingsList.vue'),
          },
          {
            name: 'deliverysetting',
            path: 'deliverysetting/:id',
            component: () => import('../pages/admin/crm/DeliverySettingsDetail.vue'),
          },
          {
            name: 'blacklists',
            path: 'blacklists',
            component: () => import('../pages/admin/crm/BlackLists.vue'),
          },
          {
            name: 'blacklist',
            path: 'blacklist/:id',
            component: () => import('../pages/admin/crm/BlackListDetail.vue'),
          },
          {
            name: 'actioncontrolling',
            path: 'actioncontrolling/:id',
            component: () => import('../pages/admin/crm/ActionControlling.vue'),
          },
          {
            name: 'defaultvalues',
            path: 'defaultvalues',
            component: () => import('../pages/admin/crm/DefaultValues.vue'),
          },
        ],
      },
      {
        name: 'stats',
        path: 'stats',
        component: RouteViewComponent,
        children: [
          {
            name: 'participations',
            path: 'particpations',
            component: () => import('../pages/admin/stats/Participations.vue'),
          },
          {
            name: 'inventory',
            path: 'inventory',
            component: () => import('../pages/admin/stats/Inventory.vue'),
          },
          {
            name: 'blocks',
            path: 'blocks',
            component: () => import('../pages/admin/stats/Blocks.vue'),
          },
          {
            name: 'samplesregarding',
            path: 'samplesregarding',
            component: () => import('../pages/admin/stats/SamplesRegarding.vue'),
          },
          {
            name: 'samplesregardingpreset',
            path: 'samplesregarding/:uid',
            component: () => import('../pages/admin/stats/SamplesRegarding.vue'),
          },
          {
            name: 'robinson',
            path: 'robinson',
            component: () => import('../pages/admin/stats/Robinson.vue'),
          },
        ],
      },
      {
        name: 'system',
        path: 'system',
        component: RouteViewComponent,
        children: [
          {
            name: 'users',
            path: 'users',
            component: () => import('../pages/admin/system/UserList.vue'),
          },
          {
            name: 'user',
            path: 'user/:id',
            component: () => import('../pages/admin/system/UserDetail.vue'),
          },
          {
            name: 'useradd',
            path: 'user',
            component: () => import('../pages/admin/system/UserDetail.vue'),
          },
          {
            name: 'sources',
            path: 'sources',
            component: () => import('../pages/admin/system/SourcesList.vue'),
          },
          {
            name: 'source',
            path: 'source/:id',
            component: () => import('../pages/admin/system/SourcesDetail.vue'),
          },
          {
            name: 'sourceadd',
            path: 'source',
            component: () => import('../pages/admin/system/SourcesDetail.vue'),
          },
          {
            name: 'categories',
            path: 'categories',
            component: () => import('../pages/admin/system/Categories.vue'),
          },
          {
            name: 'deliveryformats',
            path: 'deliveryformats',
            component: () => import('../pages/admin/system/DeliveryFormatList.vue'),
          },
          {
            name: 'deliveryformat',
            path: 'deliveryformat/:id',
            component: () => import('../pages/admin/system/DeliveryFormatDetail.vue'),
          },
          {
            name: 'actiontools',
            path: 'actiontools',
            component: () => import('../pages/admin/system/ActionTools.vue'),
          },
          {
            name: 'partners',
            path: 'partners',
            component: () => import('../pages/admin/system/PartnersList.vue'),
          },
          {
            name: 'partner',
            path: 'partner/:id',
            component: () => import('../pages/admin/system/PartnerDetail.vue'),
          },
        ],
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/admin/settings/Settings.vue'),
      },
      {
        name: 'account',
        path: 'account',
        component: RouteViewComponent,
        children: [
          {
            name: 'myaccount',
            path: 'myaccount',
            component: () => import('../pages/admin/account/MyAccount.vue'),
          },
        ],
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  //  mode: process.env.VUE_APP_ROUTER_MODE_HISTORY === 'true' ? 'history' : 'hash',
  routes,
})

// 👇 Add this part
router.beforeEach((to, from, next) => {
  const defaultTitle = 'Datahub'
  window.document.title = defaultTitle
  next()
})

export default router
